export const challengeData = {
    '0fffd7ca543d7a55a0050541e0573108': {
        name: 'Ogilvy',
        label: 'March 9 - April 9',
        dateFrom: '3/9/2023',
        dateTo: '4/9/2023'
    },
    '169d620383077128977a1c60c28e7084': {
        name: 'Ogilvy',
        label: 'March 9 - April 9',
        dateFrom: '3/9/2023',
        dateTo: '4/9/2023'
    }
};
